import { DateInput, NumberInput, TextInput } from '@core/components/Inputs';
import CodigoBarrasInput from '@core/components/Inputs/CodigoBarrasInput';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import RangeDateInput from '@core/components/Inputs/RangeDateInput';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { SelectInput } from '@core/components/Select';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip
} from '@material-ui/core';
import { formataQuantidade } from 'app/utils/mask';
import { calcularValorComDesconto } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import React, { useRef } from 'react';

const finalidades = [
  { id: 'MERCADORIA_REVENDA', title: '00 - Mercadoria para Revenda' },
  { id: 'MATERIA_PRIMA', title: '01 - Matéria-prima' },
  { id: 'EMBALAGEM', title: '02 - Embalagem' },
  { id: 'PRODUTO_EM_PROCESSO', title: '03 - Produto em Processo (produto semi-acabado)' },
  { id: 'PRODUTO_ACABADO', title: '04 - Produto Acabado' },
  { id: 'SUBPRODUTO', title: '05 - Subproduto' },
  { id: 'PRODUTO_INTERMEDIARIO', title: '06 - Produto Intermediário' },
  { id: 'MATERIAL_USO_CONSUMO', title: '07 - Material de Uso e Consumo' },
  { id: 'ATIVO_IMOBILIZADO', title: '08 - Ativo Imobilizado' },
  { id: 'SERVICOS', title: '09 - Serviços' },
  { id: 'OUTROS_INSUMOS', title: '10 - Outros insumos' },
  { id: 'OUTRAS', title: '99 - Outras' },
];

const getCurrency = (value) =>
  value !== undefined
    ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '')
    : '-';

const TabDadosProduto = () => {
  const formik = useFormikContext();

  const { errors, touched, submitCount } = formik;

  const refSwitchPromocao = useRef();

  const _errors = {
    nome: (submitCount || touched?.nome) && errors?.nome,
    codigo: (submitCount || touched?.codigo) && errors?.codigo,
    estoqueMaximo: (submitCount || touched?.estoqueMaximo) && errors?.estoqueMaximo,
    descricaoDetalhada: (submitCount || touched?.descricaoDetalhada) && errors?.descricaoDetalhada,
    tipoFinalidade: (submitCount || touched?.tipoFinalidade) && errors?.tipoFinalidade,
    codigoBarras: (submitCount || touched?.codigo) && errors?.codigoBarras,
    valorVenda: (submitCount || touched?.valorVenda) && errors?.valorVenda,
    dataValidade: (submitCount || touched?.dataValidade) && errors?.dataValidade,
    promocao: {
      vigenciaInicio: (submitCount || touched.promocao?.vigenciaInicio) && errors.promocao?.vigenciaInicio,
      tipoDesconto: (submitCount || touched.promocao?.tipoDesconto) && errors.promocao?.tipoDesconto,
      desconto: (submitCount || touched.promocao?.desconto) && errors.promocao?.desconto,
    },
  };

  const handleSetPromocao = ({ target: { checked } }) => {
    formik.setFieldValue('emPromocao', checked);

    if (checked) {
      formik.setFieldValue('promocao.tipoDesconto', 'VALOR');
    }
  };

  const valorComDesconto = calcularValorComDesconto(
    formik.values?.promocao?.tipoDesconto,
    formik.values?.valorUnitario,
    formik.values?.promocao?.desconto
  );

  const warnEstoqueMaximo =
    formik.values.estoqueMinimo !== null &&
    formik.values.estoqueMinimo !== undefined &&
    formik.values.estoqueMaximo !== null &&
    formik.values.estoqueMaximo !== undefined &&
    formik.values.estoqueMinimo > formik.values.estoqueMaximo;

  const maximo9DigitosEsquerda = (values) => {
    return !values.floatValue || values.floatValue <= 10 ** 9;
  };

  return (
    <Grid container spacing={3} className="mt-16">
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <TextInput
          id="nome"
          name="nome"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.nome}
          error={_errors.nome}
          touched={formik.touched.nome}
          maxLength={50}
          required
          fullWidth
          autoFocus
          variant="outlined"
          label="Nome do produto"
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <Tooltip placement="top-start" title="Número de referência do seu produto">
          <div>
            <TextInput
              id="codigo"
              name="codigo"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.codigo}
              error={_errors.codigo}
              required={!!_errors.codigo}
              touched={formik.touched.codigo}
              fullWidth
              maxLength={30}
              variant="outlined"
              label="Código do produto (SKU)"
            />
          </div>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="descricaoDetalhada"
          name="descricaoDetalhada"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.descricaoDetalhada}
          error={_errors.descricaoDetalhada}
          touched={formik.touched.descricaoDetalhada}
          required={!!_errors.descricaoDetalhada}
          fullWidth
          multiline
          maxLength={500}
          rows={3}
          variant="outlined"
          label="Descrição detalhada do produto"
        />
      </Grid>
      <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
        <SelectInput
          id="tipoFinalidade"
          name="tipoFinalidade"
          label="Finalidade (Bloco K)"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.tipoFinalidade}
          options={finalidades}
          error={_errors.tipoFinalidade}
          touched={!!_errors.tipoFinalidade}
        />
      </Grid>
      <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
        <CurrencyTextField
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          maximumValue="999999999.99"
          minimumValue="0"
          decimalPlaces={2}
          decimalPlacesShownOnBlur={2}
          decimalPlacesShownOnFocus={2}
          error={!!_errors.valorUnitario}
          helperText={_errors.valorUnitario || ''}
          onChange={(e, value) => {
            formik.setFieldValue('valorUnitario', value);
          }}
          onBlur={formik.handleBlur}
          id="valorUnitario"
          name="valorUnitario"
          value={formik.values?.valorUnitario}
          fullWidth
          variant="outlined"
          label="Valor unitário da venda (R$)"
        />
      </Grid>
      <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
        <ReadOnlyInput id="custoMedio" label="Custo médio (R$)" value={getCurrency(formik.values?.custoMedio)} />
      </Grid>
      <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
        <DateInput
          id="dataValidade"
          name="dataValidade"
          label="Data de validade"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.dataValidade}
          error={_errors.dataValidade}
          helperText={_errors.dataValidade}
          touched={formik.touched.dataValidade}
          fullWidth
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <NumberInput
          id="estoqueMinimo"
          label="Estoque mínimo"
          decimalScale={6}
          decimalSeparator=","
          allowNegative={false}
          isAllowed={maximo9DigitosEsquerda}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.estoqueMinimo}
          error={_errors.estoqueMinimo}
          touched={formik.touched.estoqueMinimo}
          required={!!_errors.estoqueMinimo}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <NumberInput
          id="estoqueMaximo"
          label="Estoque máximo"
          decimalScale={6}
          decimalSeparator=","
          allowNegative={false}
          isAllowed={maximo9DigitosEsquerda}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.estoqueMaximo}
          error={_errors.estoqueMaximo}
          touched={formik.touched.estoqueMaximo}
          required={!!_errors.estoqueMaximo}
          warning={warnEstoqueMaximo ? 'Confirme se o estoque máximo é realmente menor que o estoque mínimo' : false}
        />
      </Grid>
      {formik.values?.id ? (
        <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
          <ReadOnlyInput
            id="quantidadeEstoque"
            label="Quantidade em estoque"
            value={formataQuantidade(formik.values?.quantidadeEstoque)}
          />
        </Grid>
      ) : (
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <NumberInput
            id="quantidadeEstoque"
            label="Quantidade em estoque"
            decimalScale={6}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={maximo9DigitosEsquerda}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.quantidadeEstoque}
            error={_errors.quantidadeEstoque}
            touched={formik.touched.quantidadeEstoque}
            required={!!_errors.quantidadeEstoque}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <CodigoBarrasInput
          id="codigoBarras"
          name="codigoBarras"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.codigoBarras}
          error={!!_errors.codigoBarras}
          helperText={_errors.codigoBarras}
          touched={formik.touched.codigoBarras}
          required={!!_errors.codigoBarras}
          onNext={() => refSwitchPromocao.current.focus()}
          fullWidth
          variant="outlined"
          tipo="ean"
          label="Código de barras (EAN)"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          ref={refSwitchPromocao}
          control={
            <Switch
              id="emPromocao"
              name="emPromocao"
              value={formik.values?.emPromocao}
              checked={formik.values?.emPromocao}
              onChange={handleSetPromocao}
              onBlur={formik.handleBlur}
              color="primary"
            />
          }
          label="Produto em promoção"
        />
      </Grid>
      {formik.values.emPromocao && (
        <Grid container item spacing={3}>
          <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
            <RangeDateInput
              id="promocao.vigenciaInicio"
              name="promocao.vigenciaInicio"
              value={[formik.values.promocao?.vigenciaInicio, formik.values.promocao?.vigenciaFim]}
              label="Período de vigência"
              error={!!_errors.promocao?.vigenciaInicio}
              helperText={_errors.promocao?.vigenciaInicio}
              onBlur={formik.handleBlur}
              required
              onChange={(inicio, fim) => {
                formik.setFieldValue('promocao.vigenciaFim', fim);
                formik.setFieldValue('promocao.vigenciaInicio', inicio);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            <FormControl
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              style={{ width: '100%' }}
              error={!!_errors.tipo}
            >
              <InputLabel id="promocao.tipoDesconto">Tipo do desconto *</InputLabel>
              <Select
                id="promocao.tipoDesconto"
                name="promocao.tipoDesconto"
                value={formik.values?.promocao?.tipoDesconto}
                fullWidth
                label="Tipo do desconto *"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="VALOR">Valor (R$)</MenuItem>
                <MenuItem value="PERCENTUAL">Percentual (%)</MenuItem>
              </Select>
              <FormHelperText>{_errors?.promocao?.tipoDesconto || ''}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
            {formik.values.promocao?.tipoDesconto === 'VALOR' ? (
              <CurrencyTextField
                outputFormat="number"
                decimalCharacter=","
                digitGroupSeparator="."
                maximumValue="999999999"
                minimumValue="0"
                decimalPlaces={2}
                decimalPlacesShownOnBlur={2}
                decimalPlacesShownOnFocus={2}
                error={!!_errors.promocao?.desconto}
                helperText={_errors.promocao?.desconto || ''}
                onChange={(e, value) => {
                  formik.setFieldValue('promocao.desconto', value);
                }}
                onBlur={formik.handleBlur}
                id="promocao.desconto"
                name="promocao.desconto"
                value={formik.values?.promocao?.desconto}
                required
                fullWidth
                variant="outlined"
                label="Desconto (R$)"
              />
            ) : (
              <NumberInput
                required
                label="Desconto (%)"
                id="promocao.desconto"
                decimalScale={8}
                decimalSeparator=","
                allowNegative={false}
                isAllowed={(values) => {
                  return !values.floatValue || values.floatValue <= 100;
                }}
                value={formik.values.promocao?.desconto}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                touched={formik.touched.promocao?.desconto}
                error={formik.errors.promocao?.desconto}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
            <ReadOnlyInput
              id="promocao.valorComDesconto"
              label="Valor com desconto(R$)"
              value={getCurrency(valorComDesconto)}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default TabDadosProduto;
